import React from 'react';
import PropTypes from 'prop-types';

class FormGroup extends React.Component {
  static propTypes = {
    touched: PropTypes.any,
    errors: PropTypes.any,
    name: PropTypes.string.isRequired,
    help: PropTypes.string,
    children: PropTypes.array
  };

  render() {
    const { touched, errors, name, help, children } = this.props;

    return (
      <div
        className={
          touched[name] && errors[name]
            ? 'form-group m-form__group has-danger'
            : 'form-group m-form__group'
        }
      >
        <div className="m-checkbox-list">{children}</div>
        {help && <span className="m-form__help">{help}</span>}
        {touched[name] && errors[name] && (
          <div className="form-control-feedback">{errors[name]}</div>
        )}
      </div>
    );
  }
}

export default FormGroup;
